module.exports = {"id":"200389","name":"Jan Oblak","rating":"88","photo":"./data/images/photos/2/200389.png","club":{"name":"Atlético Madrid","logo":"./data/images/clubs/AtleticoMadrid.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JanOblak0.json
// module id = 1916
// module chunks = 0